/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetListForExhibition } from '../fn/admin-exhibitions-controller/admin-get-list-for-exhibition';
import { AdminGetListForExhibition$Params } from '../fn/admin-exhibitions-controller/admin-get-list-for-exhibition';
import { ItemExhibitionWithRelations } from '../models/item-exhibition-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminExhibitionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemExhibitionControllerAdminGetListForExhibition()` */
  static readonly ItemExhibitionControllerAdminGetListForExhibitionPath = '/admin/exhibitions/{id}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetListForExhibition()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForExhibition$Response(params: AdminGetListForExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemExhibitionWithRelations>>> {
    return adminGetListForExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetListForExhibition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForExhibition(params: AdminGetListForExhibition$Params, context?: HttpContext): Observable<Array<ItemExhibitionWithRelations>> {
    return this.adminGetListForExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemExhibitionWithRelations>>): Array<ItemExhibitionWithRelations> => r.body)
    );
  }

}
